import { useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';

function useAnamnesisTemplate(therapistId) {
  const [template, setTemplate] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [templateIntro, setTemplateIntro] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const { data: tmpl, error: tmplError } = await supabase
        .from('anamnesis_templates')
        .select('*')
        .eq('therapist_id', therapistId)
        .maybeSingle();
      if (tmplError) throw tmplError;

      if (tmpl) {
        setTemplate(tmpl);
        setTemplateIntro(tmpl.intro_text || '');
        const { data: qs, error: qsError } = await supabase
          .from('anamnesis_questions')
          .select('*')
          .eq('template_id', tmpl.id)
          .order('sort_order');
        if (qsError) throw qsError;
        setQuestions(qs || []);
      } else {
        setTemplate(null);
        setTemplateIntro('');
        setQuestions([]);
      }
    } catch (err) {
      setError(err.message || 'Något gick fel vid hämtning av anamnesdata.');
    }

    setLoading(false);
  }, [therapistId]);

  return { template, questions, templateIntro, setTemplateIntro, loading, error, refetch };
}

export default useAnamnesisTemplate;
